module.exports = "/images/shareEasy.svg";